import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Paper } from '@mui/material';

import { Table } from '../../../components/table/table';
import { HeadCell, Row, RowCell } from '../../../components/table/types';
import { useLazyGetProviderBalancesQuery } from '../../../api';
import { formatAmount } from '../../../utils';
import { useParams } from 'react-router-dom';

export const ProviderWallet: FC = () => {
  const { t } = useTranslation();
  const { provider } = useParams<'provider'>();
  // api
  const [getProvider, { data: krakenInfo, isLoading: isKrakenInfoLoading }] =
    useLazyGetProviderBalancesQuery();

  useEffect(() => {
    if (provider) {
      getProvider({ provider });
    }
  }, [provider]);

  // table cells and rows
  const headCells: HeadCell[] = [
    { id: '1', label: t('providers.head-cells-wallet.coin-code') },
    { id: '2', label: t('providers.head-cells-wallet.balance') },
  ];

  const rows: Row[] | undefined = krakenInfo
    ? Object.keys(krakenInfo).map((key) => {
        const cells: RowCell[] = [
          {
            name: 'coin-code',
            value: key,
          },
          {
            name: 'balance',
            value: formatAmount(krakenInfo[key]),
          },
        ];

        return { cells };
      })
    : [];

  return (
    <Grid size={{ xs: 12 }}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <Table headCells={headCells} rows={rows} />
      </Paper>
    </Grid>
  );
};
